module.exports = __webpack_public_path__ + "img/game.8076639.svg";